module.exports = [{"value":"นาย","text":"นาย"},{"value":"นาง","text":"นาง"},{"value":"นางสาว","text":"นางสาว"},{"value":"เด็กชาย","text":"เด็กชาย"},{"value":"เด็กหญิง","text":"เด็กหญิง"},{"value":"ร.ต.อ","text":"ร.ต.อ"},{"value":"ร.ต.อ หญิง","text":"ร.ต.อ หญิง"},{"value":"ว่าที่ ร.ต","text":"ว่าที่ ร.ต"},{"value":"ว่าที่ ร.ต หญิง","text":"ว่าที่ ร.ต หญิง"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/master/titleName/titleNameTH.json
// module id = Qfen
// module chunks = 2